import React from 'react';
import {
  EnquiryFormBlock,
  FullWidthVideoBlock,
  PostRichText,
  PostFeaturedText,
  PostImage,
  PostVideo,
  HowItWorksBlock,
  WhatWeDoBlock,
  CallToActionsBlock,
  ClientsTicker,
  TestimonialsBlock,
  PostFeaturedList,
  PostImageSet,
  TeamBlock,
} from './Slices';

const ENQUIRY_FORM_BLOCK_TYPE = 'enquiry_form_block';
const TEAM_BLOCK_TYPE = 'team_block';
const FULL_WIDTH_VIDEO_BLOCK_TYPE = 'full_width_video_block';
const BLOG_POST_RICH_TEXT_TYPE = 'rich_text';
const BLOG_POST_FEATURED_TEXT_TYPE = 'featured_text';
const BLOG_POST_POST_VIDEO_TYPE = 'post_video';
const BLOG_POST_POST_IMAGE_TYPE = 'post_image';
const BLOG_POST_FEATURED_LIST_TYPE = 'featured_list';
const BLOG_POST_IMAGE_SET_TYPE = 'post_image_set';
const WHAT_WE_DO_BLOCK_TYPE = 'what_we_do_block';
const HOW_IT_WORKS_BLOCK_TYPE = 'how_it_works_block';
const CALL_TO_ACTIONS_BLOCK_TYPE = 'call_to_actions_block';
const CLIENTS_TICKER_TYPE = 'clients_ticker';
const TESTIMONIALS_BLOCK_TYPE = 'testimonials_block';

const SliceZone = (props) => {
  const {
    allSlices,
    location,
  } = props;
  const isHome = Boolean(location.pathname === '/');
  const slices = allSlices && allSlices.map((slice) => {
    switch (slice.sliceType) {
      case ENQUIRY_FORM_BLOCK_TYPE:
        return (
          <EnquiryFormBlock
            key={slice.id}
            data={slice}
            location={location}
            isHome={isHome}
          />
        );
      // case INSTAGRAM_FEED_TYPE:
      //   return (
      //     <InstagramFeed
      //       key={slice.id}
      //       data={slice}
      //     />
      //   );
      case FULL_WIDTH_VIDEO_BLOCK_TYPE:
        return (
          <FullWidthVideoBlock
            key={slice.id}
            data={slice}
          />
        );
      case BLOG_POST_RICH_TEXT_TYPE:
        return (
          <PostRichText
            key={slice.id}
            data={slice}
          />
        );
      case BLOG_POST_FEATURED_TEXT_TYPE:
        return (
          <PostFeaturedText
            key={slice.id}
            data={slice}
          />
        );
      case BLOG_POST_POST_IMAGE_TYPE:
        return (
          <PostImage
            key={slice.id}
            data={slice}
          />
        );
      case BLOG_POST_POST_VIDEO_TYPE:
        return (
          <PostVideo
            key={slice.id}
            data={slice}
          />
        );
      case BLOG_POST_FEATURED_LIST_TYPE:
        return (
          <PostFeaturedList
            key={slice.id}
            data={slice}
          />
        );
      case BLOG_POST_IMAGE_SET_TYPE:
        return (
          <PostImageSet
            key={slice.id}
            data={slice}
          />
        );
      case WHAT_WE_DO_BLOCK_TYPE:
        return (
          <WhatWeDoBlock
            key={slice.id}
            data={slice}
            isHome={isHome}
          />
        );
      case HOW_IT_WORKS_BLOCK_TYPE:
        return (
          <HowItWorksBlock
            key={slice.id}
            data={slice}
            isHome={isHome}
          />
        );
      case CALL_TO_ACTIONS_BLOCK_TYPE:
        return (
          <CallToActionsBlock
            key={slice.id}
            data={slice}
            isHome={isHome}
          />
        );
      case CLIENTS_TICKER_TYPE:
        return (
          <ClientsTicker
            key={slice.id}
            data={slice}
            isHome={isHome}
          />
        );
      case TESTIMONIALS_BLOCK_TYPE:
        return (
          <TestimonialsBlock
            key={slice.id}
            data={slice}
            isHome={isHome}
          />
        );
      case TEAM_BLOCK_TYPE:
        return (
          <TeamBlock
            key={slice.id}
            data={slice}
          />
        );
      default:
        return null;
    }
  });
  return (
    <div className="slice-zone">
      {slices}
    </div>
  );
};

export default SliceZone;
